import { IIconProps } from "@/components/icons/interface";
const OutputsAdminIcon = ({ width, height, color }: IIconProps) => {
  const strokeColor = color;
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7.5H20M4 12.5H14M4 17.5H10"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="18" cy="17.5" r="3" stroke={strokeColor} strokeWidth="2" />
      <path
        d="M20 19.5L21.5 21"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export { OutputsAdminIcon };
